<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <h3 class="text-center">View Laboratory Provider</h3>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-card>
            <v-card-text>
              <p>Name <b v-html="lab.name"></b></p>
              <p>Location <b v-html="lab.location"></b></p>
              <p>Phone <b v-html="lab.phone"></b></p>
              <p>Email <b v-html="lab.email"></b> <a :href="'mailto:' + lab.email" v-if="lab.email" target="_blank">Send Email</a></p>
              <p>Saved By <b v-html="lab.user.name"></b></p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="edit = !edit" small title="Edit" color="orange">Edit</v-btn>
            </v-card-actions>
            <v-card>
              <v-card-title>
                <input type="file" ref="tests" style="visibility: hidden;" @change="fileChanged" accept=".xlsx, .csv, .xls">
                <a href="/documents/laboratorytests.xlsx" download v-show="!file">Sample</a>
                <v-spacer></v-spacer>
                <v-btn small text @click="uploadTests" v-if="!file">Select File for Upload</v-btn>
                <span v-else>
                  <span v-html="file.name" class="pr-1"></span>
                  <v-icon class="red--text pr-1" role="button" @click="$refs.tests.click()">mdi-close-box-outline</v-icon>
                  <v-btn small color="primary" @click="performUpload">Upload</v-btn>
                </span>
              </v-card-title>
            </v-card>
          </v-card>
        </v-flex>
        <v-flex xs12 sm8 md8 class="pa-1">
          <v-card>
            <v-card-title class="primary pb-1 pt-1">
              Laboratory Tests
              <v-spacer></v-spacer>
              <v-btn small @click="addTests = !addTests" class="secondary">Add</v-btn>
            </v-card-title>
            <v-card-text>
              <view-lab-tests :tests="tests"></view-lab-tests>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <modal-dialog :open="edit" @close="edit = false">
        <template slot="title">Edit Laboratory</template>
        <edit-lab :lab="laboratory" @saved="edit = false"></edit-lab>
      </modal-dialog>
      <modal-dialog :open="addTests" @close="addTests = false">
        <template slot="title">Add Tests for Provider</template>
        <add-lab-test :laboratory="laboratory" @saved="addTests = false"></add-lab-test>
      </modal-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const EditLab = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "laboratories" */ '@/Components/Laboratories/edit')
  const AddLabTest = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "laboratories" */ '@/Components/Labtests/create')
  const ViewLabTests = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "laboratories" */ '@/Components/Labtests/index')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')

  export default {
    name: 'ViewLaboratoryProvider',
    props: [
      'laboratory'
    ],
    layout,
    components: {
      EditLab,
      AddLabTest,
      ViewLabTests,
      ModalDialog,
    },
    metaInfo () {
      return {
        title: 'Laboratory Service Provider - ' + this.lab.name,
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        lab: this.laboratory,
        edit: false,
        addTests: false,
        file: ''
      }
    },
    methods: {
      fileChanged (e) {
        let file

        file = e.target.files[0]
        // console.log(file)
        this.file = file
      },
      performUpload () {
        let file, field
        field = this.$refs.tests
        file = field.files[0]
        //  console.log(file)
         let data = new FormData()
         data.append('file', file)
         this.$inertia.post('/laboratories/' + this.laboratory.id + '/import', data)
      },
      uploadTests () {
        swal({
          title: 'Upload Tests for this Provider',
          text: this.laboratory.name + '<br> The test you upload will ONLY be saved if the name is unique, otherwise, the fields will be updated. <br> Only spreadsheet (excel) allowed.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Continue',
        },
        function () {
          this.$refs.tests.click()
        }.bind(this))
      }
    },
    computed: {
      tests () {
        return this.laboratory.laboratory_tests
      }
    },
  }
</script>
